import React from 'react';
import { CSSTransition } from 'react-transition-group';
import Select from 'swag-client-common/components/pickers/ecommerce-select';
import { Tooltip } from 'swag-client-common/components/info/tooltip/tooltip';
import { Placement } from 'swag-client-common/constants';
import { ErrorMessage } from 'swag-client-common/components/partials/cart/error-message';
import tooltipImage from 'assets/img/crinkle-paper-tooltip-image.png';
import InfoIcon from 'swag-client-common/components/icons/info-icon';
import errorAnimationClasses from '../../../../../../animations/error.anim.scss';
import CrinklePaperPicker from './crinkle-paper-picker';
import classes from './box-notecard-and-crinkle-paper.scss';
const tooltipStyles = {
  popper: classes.tooltipPopper,
  tooltip: classes.tooltipRoot
};
const imageTooltipStyles = {
  popper: classes.imageTooltipPopper,
  tooltip: classes.tooltipRoot
};
export function BoxNotecardAndCrinklePaperComponent(props) {
  const {
    notecardOption,
    onChangeNotecardOption,
    boxItemsId,
    isSpecialBoxProductsCustomizable,
    crinklePaperOption,
    onChangeCrinklePaperOption,
    crinklePaperVariants,
    notecardError,
    crinklePaperError,
    notecardOptions,
    showNotecardTooltip
  } = props;
  if (!isSpecialBoxProductsCustomizable) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.boxCustomizations
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.boxCustomizationItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.customizationTitle
  }, /*#__PURE__*/React.createElement("span", null, "Would you like a custom notecard?"), showNotecardTooltip && /*#__PURE__*/React.createElement(Tooltip, {
    title: "After you place your order we will work with you to get your artwork arranged.",
    placement: Placement.RIGHT,
    mode: "light",
    className: classes.infoWrapper,
    classes: tooltipStyles
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    className: classes.infoButton
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.customizationSelect,
    "data-select": "BoxNotecard"
  }, /*#__PURE__*/React.createElement(Select, {
    value: notecardOption,
    onChange: e => {
      onChangeNotecardOption(boxItemsId, e.target.value);
    },
    options: notecardOptions,
    placeholder: "Select an option"
  })), /*#__PURE__*/React.createElement(CSSTransition, {
    in: !!notecardError,
    timeout: 500,
    classNames: errorAnimationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ErrorMessage, {
    error: notecardError
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.boxCustomizationItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.customizationTitle
  }, /*#__PURE__*/React.createElement("span", null, "What color crinkle paper?"), /*#__PURE__*/React.createElement(Tooltip, {
    title: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
      src: tooltipImage,
      alt: "Crinkle Paper image"
    })),
    placement: Placement.RIGHT,
    mode: "light",
    className: classes.infoWrapper,
    classes: imageTooltipStyles
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    className: classes.infoButton
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.customizationSelect,
    "data-select": "BoxPaper"
  }, /*#__PURE__*/React.createElement(CrinklePaperPicker, {
    boxItemsId: boxItemsId,
    crinklePaperOption: crinklePaperOption,
    onChangeCrinklePaperOption: onChangeCrinklePaperOption,
    crinklePaperVariants: crinklePaperVariants
  })), /*#__PURE__*/React.createElement(CSSTransition, {
    in: !!crinklePaperError,
    timeout: 1500,
    classNames: errorAnimationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ErrorMessage, {
    error: crinklePaperError
  })))));
}